module.exports = __webpack_public_path__ + "static/media/join-data-icon.c7590d47.svg";